






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PromoMailCheckboxPanel extends Vue {
  @Prop({ required: true })
  readonly userFlgState!: boolean;

  checked = this.userFlgState;

  onCheckboxChange() {
    this.$emit('input', this.checked);
  }
}
